let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("afGg1")).then(() => parcelRequire('lI543'));